import { render, staticRenderFns } from "./livingPreview.vue?vue&type=template&id=3d511f70&scoped=true&"
import script from "./livingPreview.vue?vue&type=script&lang=js&"
export * from "./livingPreview.vue?vue&type=script&lang=js&"
import style0 from "./livingPreview.vue?vue&type=style&index=0&id=3d511f70&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d511f70",
  null
  
)

export default component.exports